export default {
  code: 'owner-reporting',
  name: 'Owner Reporting',
  version: 'v1',
  iconKey: 'owner-reporting',
  pages: [
    { key: 'dashboard', title: 'Dashboard', path: 'dashboard' },
    { key: 'calendar', title: 'Calendar', path: 'calendar' },
    { key: 'service-packages', title: 'Service Packages', path: 'service-packages' },
    { key: 'unit-config', title: 'Unit Config', path: 'unit-config' },
    { key: 'revenue', title: 'Monthly Revenue', path: 'revenue' },
    { key: 'expenses', title: 'Monthly Expenses', path: 'expenses' },
    { key: 'installments', title: 'Owner Instalments', path: 'installments' },
    { key: 'reporting', title: 'Manage Reporting', path: 'reporting' },
    { key: 'settings', title: 'Event Actions', path: 'settings', audience: 'admin' },
    { key: 'owner-reports', title: 'Owner Reports', path: 'owner-reports', audience: 'owner' },
  ],
  uiContributions: [
    {
      slotId: 'unit.owner-reporting',
      page: 'unit',
      placement: 'tab',
      title: 'Owner Reporting',
      componentKey: 'OwnerReportingUnitSettings',
    },
  ],
};
